import '../MoveHomepage.css';

import WinterStatus from '../../Admin/Winteredit';

import BecomeDriver from './Driver';
import GetQuote from './GetQuote';
import Stats from './Stats';
import LogosForm from '../../Admin/Logosupload';
import LogoSlideshow from '../Logoslideshow';
import TermsAndConditions from './TermsAndConditions.';
import AddressSelector from '../AddressFinder';
import AddressFinder from '../AddressFinder';
import PostcodeSearch from '../AddressFinder';
import PostcodeLookup from '../AddressFinder';
import AddressToPostcode from '../AddressFinder';
import GeoapifyPostalCodeSearch from '../Addresscheck';
import GeoapifyAddressLookup from '../Addresscheck';
import AddressAutocomplete from '../Addresscheck';
import UkAddressSelect from '../Addresscheck';
import NominatimAddressSearch from '../Addresscheck';
import NominatimAutofill from '../Addresscheck';
import TomTomAutocomplete from '../Addresscheck';
import OpenCageSearch from '../Addresscheck';
import Timing from '../Timing';
import AboutUs from './Aboutus';

function MoveHomePageIntro() {
  return (
    <>
    
      {/* <div className="content" style={{backgroundColor:'white'}}>
    
      <h1>We work with</h1>
      <img src={logoimage} alt="Our Partners' Logos" />
    </div> */}
    <AboutUs/>
    <Stats/>

{/* <TermsAndConditions/> */}
{/* <GeoapifyPostalCodeSearch/> */}
{/* <GeoapifyAddressLookup/> */}
{/* <AddressAutocomplete/> */}
<GetQuote/>
    <BecomeDriver/>
    {/* <AddressAutocomplete/> */}
    {/* <NominatimAutofill/>
     */}
    </>
  );
}

export default MoveHomePageIntro;
